import { render, staticRenderFns } from "./PageStats.vue?vue&type=template&id=1b9ed807"
import script from "./PageStats.vue?vue&type=script&lang=js"
export * from "./PageStats.vue?vue&type=script&lang=js"
import style0 from "./PageStats.vue?vue&type=style&index=0&id=1b9ed807&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports